import { createFileRoute, Outlet } from "@tanstack/react-router";

import PublicLayout from "@/components/ui/layout/public-layout";

export const Route = createFileRoute("/(error)")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PublicLayout>
      <Outlet />
    </PublicLayout>
  );
}
